export interface Theme {
  name: string;
  colors: string[];
  baseTextColor: "light" | "dark";
  seed?: string; // Optional seed for GradientBlobContainer
}

export const defaultThemes: Theme[] = [
  {
    name: "Aurora",
    colors: [
      "#3D5AFE",
      "#00E676",
    ],
    baseTextColor: "light",
    seed: "aurora",
  },
  {
    name: "Cosmos",
    colors: ["#1DE9B6", "#651FFF"],
    baseTextColor: "light",
    seed: "cosmos",
  },
  {
    name: "Galaxy",
    colors: ["#9B59B6", "#3498DB"],
    baseTextColor: "light",
    seed: "galaxy",
  },
  {
    name: "Horizon",
    colors: [
      "#FFD600",
      "#FF9100",
    ],
    baseTextColor: "light",
    seed: "horizon",
  },
  {
    name: "Nebula",
    colors: ["#651FFF", "#3D5AFE"],
    baseTextColor: "light",
    seed: "nebula",
  },
  {
    name: "Rocketship",
    colors: ["#F50057", "#3D5AFE"],
    baseTextColor: "light",
    seed: "rocketship",
  },
  {
    name: "Stellar",
    colors: ["#FF6B35", "#4ECDC4"],
    baseTextColor: "light",
    seed: "stellar",
  },
  {
    name: "Zenith",
    colors: ["#00BCD4", "#4CAF50"],
    baseTextColor: "light",
    seed: "zenith",
  },

];

export const LOCAL_STORAGE_THEME_KEY = "sidebarLayoutTheme";

/**
 * Merges company themes with default themes, prioritizing company themes
 */
export function mergeThemes(
  companyThemes: Theme[] = [],
  workspaceThemesExclusive = false,
): Theme[] {
  if (companyThemes.length === 0) {
    return defaultThemes;
  }

  if (workspaceThemesExclusive) {
    return companyThemes;
  }

  // Use company themes first, then add any default themes not already present
  const companyThemeNames = new Set(companyThemes.map((t) => t.name));
  const additionalDefaults = defaultThemes.filter(
    (t) => !companyThemeNames.has(t.name)
  );

  return [...companyThemes, ...additionalDefaults];
}

export const getInitialTheme = (
  availableThemes: Theme[] = defaultThemes
): Theme => {
  if (typeof window === "undefined") {
    // Guard for SSR or environments without window
    // Ensure availableThemes is not empty before accessing index 0
    return availableThemes.length > 0
      ? availableThemes[0]
      : {
          name: "Fallback",
          colors: ["#CCCCCC", "#AAAAAA"],
          baseTextColor: "dark",
          seed: "fallback theme",
        };
  }
  const savedThemeName = localStorage.getItem(LOCAL_STORAGE_THEME_KEY);
  if (savedThemeName) {
    const foundTheme = availableThemes.find(
      (theme) => theme.name === savedThemeName
    );
    if (foundTheme) {
      return foundTheme;
    }
  }
  if (availableThemes.length === 0) {
    console.error("CRITICAL: No themes available.");
    return {
      name: "Fallback",
      colors: ["#CCCCCC", "#AAAAAA"],
      baseTextColor: "dark",
      seed: "fallback theme",
    };
  }
  return availableThemes[0];
};
